/* TODO: t() */
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import FormField from '../helpers/FormField';
import ControlledFormView from './ControlledFormView';

import { FileDescRuntype } from '../../../../runtypes/FileDescRuntype';
import { FileDesc } from '../../../../types/shared/FileDesc';
import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  readOnly?: boolean;
  definition: FormFieldDefinition;
  onChange?: (id: string, file: FileDesc | null) => void;
};

type State = {
  selectedFile: FileDesc | null | undefined;
};

class FileUploadElementFormView extends PureComponent<Props, State> {
  state: State = {
    selectedFile: null,
  };

  render() {
    let { props } = this;
    return (
      <FormField {...props}>
        <View style={styles.fieldDiv}>{this._renderField()}</View>
      </FormField>
    );
  }

  _renderField = () => {
    let { props, state } = this;
    let { selectedFile } = state;
    return (
      <ControlledFormView
        {...props}
        selectedFile={selectedFile}
        onChange={(selectedFile) => {
          this.setState({ selectedFile });
          let { onChange, definition } = this.props;
          if (onChange) {
            onChange(definition.id, selectedFile);
          }
        }}
      />
    );
  };

  setValue = (value: unknown) => {
    if (FileDescRuntype.guard(value)) {
      this.setState({ selectedFile: value });
    }
  };

  getValue = () => {
    let { selectedFile } = this.state;
    return selectedFile ? { ...selectedFile } : null;
  };
}

let styles = StyleSheet.create({
  fieldDiv: {
    paddingVertical: 10,
    flexDirection: 'row',
  },
});

export default FileUploadElementFormView;
